import i18n from "../../../../constants/i18n";
import { TReport, TCorePage } from "../../../../Types";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Text from "../../../../core/et3-text";
import AuditorAuditReportPage from "./auditor-audit-report-page";

const ReportTitleTexts = withLiteObserverAndTheme<{
  report: TReport;
  pageName: TCorePage;
  takenActionType: string;
}>((props) => {
  const { report, pageName, takenActionType, theme } = props;
  const { colors, unitX, unitY } = theme;
  const { reporterUsername, reportedUsername } = report;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      fDirection="column"
      justifyContent="space-around"
      alignItems="center"
      withShadow={false}
      width={500}
      height={50}
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="space-around"
        alignItems="center"
        withShadow={false}
        width={400}
        height={40}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Text
          fontFamily={"BOLD"}
          fontSize={18}
          text={`${i18n.get("FROM")} ${reporterUsername}`}
          isSpan={false}
          color={colors.all.bondiBlue}
          style={{
            width: 200 * unitX,
            height: 50 * unitY,
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            textAlign: "left"
          }}
        />
        <Et3Text
          fontFamily={"BOLD"}
          fontSize={18}
          text={`${i18n.get("TO")} ${reportedUsername}`}
          isSpan={false}
          color={colors.all.bondiBlue}
          style={{
            width: 200 * unitX,
            height: 50 * unitY,
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            textAlign: "left"
          }}
        />
      </ET3Div>
      <AuditorAuditReportPage
        pageName={pageName}
        takenActionType={takenActionType}
      />
    </ET3Div>
  );
});
export default ReportTitleTexts;
